import { Product, SaleParsed } from "../database/db";

import { Bundle } from "../database/db";

export interface BasketItem extends Product {
  quantity: number;
}

export interface BasketData {
  items: BasketItem[];
  bundles: Bundle[];
  adjustedTotal: number | null;
  notes: string | null;
}

export const calculateBasketTotal = (basketData: BasketData) => {
  const calculatedSubtotal = basketData.items.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );
  const bundleSubtotal = basketData.bundles.reduce(
    (sum, bundle) => sum + bundle.discountAmount,
    0
  );
  return calculatedSubtotal - bundleSubtotal;
};

export const calculateBasketTotalFromSale = (sale: SaleParsed) => {
  return calculateBasketTotal({
    items: sale.products.map((product) => ({
      ...product.product,
      quantity: product.quantity,
    })),
    bundles: sale.bundles,
    adjustedTotal: sale.salePrice || null,
    notes: sale.notes || null,
  });
};
